var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7998 6.9998L6.6998 9.89981C6.88314 10.0831 6.9748 10.3165 6.9748 10.5998C6.9748 10.8831 6.88314 11.1165 6.6998 11.2998C6.51647 11.4831 6.28314 11.5748 5.9998 11.5748C5.71647 11.5748 5.48314 11.4831 5.2998 11.2998L0.699805 6.6998C0.599805 6.5998 0.528971 6.49147 0.487305 6.3748C0.445638 6.25814 0.424805 6.13314 0.424805 5.9998C0.424805 5.86647 0.445638 5.74147 0.487305 5.6248C0.528971 5.50814 0.599805 5.3998 0.699805 5.2998L5.2998 0.699805C5.48314 0.516471 5.71647 0.424805 5.9998 0.424805C6.28314 0.424805 6.51647 0.516471 6.6998 0.699805C6.88314 0.883138 6.9748 1.11647 6.9748 1.3998C6.9748 1.68314 6.88314 1.91647 6.6998 2.0998L3.7998 4.9998H16.9998C17.2831 4.9998 17.5206 5.09564 17.7123 5.2873C17.904 5.47897 17.9998 5.71647 17.9998 5.9998C17.9998 6.28314 17.904 6.52064 17.7123 6.7123C17.5206 6.90397 17.2831 6.9998 16.9998 6.9998H3.7998Z",
    fill: "#0080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left-arrow-icon.e76f7a473200da3958f0c69ab736392a.svg";
export { ForwardRef as ReactComponent };